import { resolveUrl } from "~/utils/url/urlResolver";
import { getCsrfValue } from "~/common/utils/ApiHelper";

const url = resolveUrl("/cad/initialConfig");

export async function fetchInitialConfiguration({ partId, selectionPath }: { partId: string; selectionPath: string }) {
  const response = await fetch(url, {
    body: JSON.stringify({ partId, selectionPath }),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });

  return response.json();
}
